//
//
//
import myAxios from '../functions/myAxios'
import {
  showSnackbar
} from "../components/MySnackbar/globalActions"

export default async function sendToTelegram(idForTg) {
  //
  if (window.confirm(`آیا مایل به ارسال جزئیات سند در تلگرام هستید؟`) === true) {
    // setLoading(true);
    try {
      let res = await myAxios({
        method: 'put',
        url: `/api/doc/whatsapp`,
        data: {
          mid: idForTg
        }
      });
      if (res && res.data && res.data.insert) {
        showSnackbar("اطلاعات با موفقیت به تلگرام ارسال شد", 'success')
      }
    } catch (err) {
      console.log(`sendToTelegram => ${err}`);
    }
  }
  //end
}
